import React, { useState } from 'react';
import './Formulario.css';
import { Button, Toast } from 'react-bootstrap';
import axios from 'axios';

function Formulario() {

  const [campos, setFormData] = useState({
    email: '',
    nome: '',
    mensagem: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSucesso, setIsSucesso] = useState(false);
  const [isErro, setisErro] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...campos,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsSucesso(false);
    setisErro(false);

    try {
      const formData = new FormData();
      Object.keys(campos).forEach(key => formData.append(key, campos[key]));
      axios.post(process.env.REACT_APP_API_EMAIL_FORMULARIO,
        formData)
        .then(response => {
          setIsLoading(false);

          if (response.data.status === "200" && response.data.msg === "sucesso") {
            setIsSucesso(true);
            setisErro(false);
            // Mostrar Toast de sucesso
            setShowToast(true);
            // Limpar campos em caso de sucesso
            setFormData({
              email: '',
              nome: '',
              mensagem: ''
            });
          } else {
            setIsSucesso(false);
            setisErro(true);
          }
        });

    } catch (error) {
      console.error('Erro ao enviar o formulário:', error);
      setIsLoading(false);
      setisErro(true);
    }
  };

  return (
    <div id="formulario" className="position-relative"> {/* Adiciona a classe position-relative para posicionar os modais */}
      <form className="my-form" onSubmit={handleSubmit}>
        <p id="contact">Contato</p>

        <div className="mb-3">
          <label htmlFor="nome" className="form-label">Nome</label>
          <input type="text" className="form-control" id="nome" name="nome" value={campos.nome} aria-label="Nome" onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">Seu E-mail</label>
          <input type="email" className="form-control" id="email" name="email" value={campos.email} placeholder="email@email.com" onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label htmlFor="mensagem" className="form-label">Sua mensagem</label>
          <textarea className="form-control" id="mensagem" name="mensagem" value={campos.mensagem} rows="3" onChange={handleInputChange} required></textarea>
        </div>

        <div className="btnVerde">
          <Button type="submit" id="envie">Enviar Mensagem</Button>
        </div>
      </form>

      {isLoading && <div className="loader">
        <div className="spinner-border text-success" role="status">
          <span className="sr-only"></span>
        </div>&nbsp;&nbsp;Enviando...</div>
      }

      {isSucesso &&
        <div className="modal-overlay d-flex justify-content-center align-items-center"> {/* Adiciona o contêiner com a classe modal-overlay */}
          <div className="modal-content alert alert-success" id="msgSuccesso">Mensagem enviada com sucesso.</div>
        </div>
      }

      {isErro &&
        <div className="modal-overlay d-flex justify-content-center align-items-center"> {/* Adiciona o contêiner com a classe modal-overlay */}
          <div className="modal-content alert alert-danger" id="msgErro">Nenhum processamento realizado. Aguarde alguns minutos e tente novamente</div>
        </div>
      }

      {/* Toast de sucesso Bootstrap */}
      <Toast 
        show={showToast} 
        onClose={() => setShowToast(false)} 
        delay={3000} 
        autohide
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999
        }}
      >
        <Toast.Header className="bg-success text-white">
          <strong className="me-auto">Sucesso!</strong>
        </Toast.Header>
        <Toast.Body>
          Mensagem enviada com sucesso!
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default Formulario;
